import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChatAvatarComponent } from './chat-avatar/chat-avatar.component';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';
import { ChatInputComponent } from './chat-input/chat-input.component';
import { ChatConfigComponent } from './chat-config/chat-config.component';
import { ChatService } from './chatbot-rasa.service';
import { KeysPipe } from '@app/@core/pipes/array-keys.pipe';
import { CardiChatRedbirdAiModule } from '@pics-module/chat-redbird-ai';
@NgModule({
    imports: [CommonModule, BrowserAnimationsModule, CardiChatRedbirdAiModule],
    declarations: [ChatAvatarComponent, ChatWidgetComponent, ChatInputComponent, ChatConfigComponent, KeysPipe],
    exports: [ChatWidgetComponent, ChatConfigComponent],
    providers: [ChatService],
    schemas: [NO_ERRORS_SCHEMA]
})
export class ChatbotRasaModule {}
